import { useFormikContext } from 'formik'
import { useTranslation } from 'react-i18next'

import { Associations } from 'src/components/associations'
import { HelperWrapper } from 'src/components'
import { useProductsSelection } from 'src/hooks'
import { AssociationsType, IJourneyForm } from 'src/types'

interface IProps {
  isDisabled?: boolean
}

const ProductsAssociationInput = ({ isDisabled }: IProps) => {
  const [t] = useTranslation()
  const { values, setFieldValue } = useFormikContext<IJourneyForm>()

  const setSelectedProducts = (ids: string[]) => setFieldValue('selectedProducts', ids)
  const { handleSelectedProduct, selectedProductIcons } = useProductsSelection(
    values.selectedProducts,
    setSelectedProducts,
  )

  return (
    <Associations
      disabled={isDisabled}
      setSelectedItems={setSelectedProducts}
      type={AssociationsType.PRODUCTS}
      description={<HelperWrapper t="products-association-title" isColorInherited size={12} />}
      selectedItems={values.selectedProducts}
      handleSelectItem={handleSelectedProduct}
      selectedIcons={selectedProductIcons}
    />
  )
}

export { ProductsAssociationInput }
